// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"260ae84f","292":"e9f2c82d","787":"dce748f8","860":"f35b9737"}[chunkId] + ".chunk.js";
};